import { BondBoeFilingListingConfig } from "../components/operations/boe-filing-bond/config/bond-boe-filing-listing.config";

export const PermissionConstants = {
  USERS: {
    NAV: 'NAV_USERS_VIEW_USER',
    EDIT: 'ACTION_USERS_EDIT_USER',
    LIST: 'ACTION_USERS_LIST_USER',
    CREATE: 'ACTION_USERS_CREATE_USER'
  },
  REPORTS: {
    NAV: 'NAV_REPORTS_LIST',
    ADMIN: 'NAV_REPORTS_ADMIN',
  },
  FINANCES: {
    VIEW_CUSTOMER_AGREEMENT: 'NAV_FINANCES_VIEW_CUSTOMER_AGREEMENT',
    VIEW_CHARGE_GROUP: 'NAV_FINANCES_VIEW_CHARGE_GROUP'
  },
  INVOICES:{
    NAV: 'NAV_FINANCES_VIEW_INVOICE',
    EDIT_BILLING_DATE: 'FIELD_INVOICE_EDIT_BILLING_DATE'
  },
  MASTERS: {
    VESSEL_PORT_TRAIN_DETAIL_MASTER: {
      NAV: 'NAV_MASTERS_VIEW_VESSEL_PORT_TRAIN_DETAIL'
    },
    VENDOR_MASTER: {
      NAV: 'NAV_MASTERS_VIEW_VENDOR'
    },
    TRAILER_MASTER: {
      NAV: 'NAV_MASTERS_VIEW_TRAILER'
    },
    STATE_MASTER: {
      NAV: 'NAV_MASTERS_VIEW_STATE'
    },
    SERVICE_MASTER: {
      NAV: 'NAV_MASTERS_VIEW_SERVICE'
    },
    PACKAGE_MASTER: {
      NAV: 'NAV_MASTERS_VIEW_PACKAGE'
    },
    LOCATION_MASTER: {
      NAV: 'NAV_MASTERS_VIEW_LOCATION'
    },
    EQUIPMENT_MASTER: {
      NAV: 'NAV_MASTERS_VIEW_EQUIPMENT'
    },
    CUSTOMER_MASTER: {
      NAV: 'NAV_MASTERS_VIEW_CUSTOMER'
    },
    COUNTRY_MASTER: {
      NAV: 'NAV_MASTERS_VIEW_COUNTRY'
    },
    COMMODITY_CATEGORY_MASTER: {
      NAV: 'NAV_MASTERS_VIEW_COMMODITY_CATEGORY'
    },
    COMMODITY_MASTER: {
      NAV: 'NAV_MASTERS_VIEW_COMMODITY'
    },
    CITY_MASTER: {
      NAV: 'NAV_MASTERS_VIEW_CITY'
    },
    BANK_MASTER: {
      NAV: 'NAV_MASTERS_VIEW_BANK'
    },
    VEHICLETYPE_MASTER: {
      NAV: 'NAV_MASTERS_VIEW_VEHICLE_TYPE',
      EDIT: 'ACTION_MASTERS_EDIT_VEHICLE_TYPE',
      LIST: 'ACTION_MASTERS_LIST_VEHICLE_TYPE',
      CREATE: 'ACTION_MASTERS_CREATE_VEHICLE_TYPE',
    },
    WAREHOUSE_MASTER: {
      NAV: 'NAV_MASTERS_VIEW_WAREHOUSE',
      EDIT: 'ACTION_MASTERS_EDIT_WAREHOUSE',
      LIST: 'ACTION_MASTERS_LIST_WAREHOUSE',
      CREATE: 'ACTION_MASTERS_CREATE_WAREHOUSE',     },
    WAREHOUSE_RESERVATION: {
      NAV: 'NAV_MASTERS_VIEW_WAREHOUSE_RESERVATION',
      EDIT: 'ACTION_MASTERS_EDIT_WAREHOUSE_RESERVATION',
      LIST: 'ACTION_MASTERS_LIST_WAREHOUSE_RESERVATION',
      CREATE: 'ACTION_MASTERS_CREATE_WAREHOUSE_RESERVATION',     },
  },
  IGM_DESK: {
    NAV: 'NAV_OPERATIONS_VIEW_IGM_DESK'
  },
  ITEM_FILING: {
    NAV: 'NAV_OPERATIONS_VIEW_ITEM_FILING'
  },
  DOCUMENTATION: {
    ITEM_FILING: {
      NAV: 'NAV_DOCUMENTATION_VIEW_ITEM_FILING'
    },
    SHIPPING_BILL: {
      NAV: 'NAV_DOCUMENTATION_VIEW_SHIPPING_BILL'
    },
    COOC_UPDATE: {
      NAV: 'NAV_DOCUMENTATION_COOC_UPDATE'
    },
    EX_BOE_FILING: {
      NAV: 'NAV_DOCUMENTATION_EX_BOE_FILING'
    },
    BOND_BOE_FILING: {
      NAV: 'NAV_DOCUMENTATION_BOND_FILING'
    },
    BOND_SPACE_CERTIFICATE: {
      NAV: 'NAV_DOCUMENTATION_BOND_NOC'
    }
  },
  TALLY: {
    NAV: 'NAV_OPERATIONS_VIEW_TALLY'
  },
  JOB_ORDER: {
    NAV: 'NAV_OPERATIONS_VIEW_IMPORT_JOB_ORDER'
  },
  HOLD: {
    NAV: 'NAV_OPERATIONS_VIEW_HOLD'
  },
  GATE_IN:{
    TRAILER: {
      NAV: 'NAV_OPERATIONS_VIEW_TRAILER_GATE_IN'
    },
    TRUCK: {
      NAV: 'NAV_OPERATIONS_VIEW_TRUCK_GATE_IN'
    },
    CONTAINER: {
      NAV: 'NAV_OPERATIONS_VIEW_CONTAINER_GATE_IN'
    }
  },
  GATE_OUT:{
    TRAILER: {
      NAV: 'NAV_OPERATIONS_VIEW_TRAILER_GATE_OUT'
    },
    TRUCK: {
      NAV: 'NAV_OPERATIONS_VIEW_TRUCK_GATE_OUT'
    },
    CONTAINER: {
      NAV: 'NAV_OPERATIONS_VIEW_CONTAINER_GATE_OUT'
    },
    CLOSE_FORCE_GATEOUT: {
      NAV: 'NAV_OPERATIONS_VIEW_FORCE_GATE_OUT'
    }
  },
  INVENTORY:{
    CONTAINER: {
      NAV: 'NAV_INVENTORIES_VIEW_CONTAINER'
    },
    VEHICLE: {
      NAV: 'NAV_INVENTORIES_VIEW_VEHICLE'
    }
  },
  CHARGE: {
    NAV: 'NAV_FINANCES_VIEW_CHARGE',
    LIST: 'ACTION_FINANCES_LIST_CHARGE',
    CREATE: 'ACTION_FINANCES_CREATE_CHARGE',
    EDIT: 'ACTION_FINANCES_EDIT_CHARGE',
    VIEW: 'ACTION_FINANCES_VIEW_CHARGE',
    VIEW_TARIFF: 'ACTION_FINANCES_CHARGE_VIEW_TARIFF',
    EDIT_TARIFF: 'ACTION_FINANCES_CHARGE_EDIT_TARIFF',
  },
  CHARGE_GROUP: {
    NAV: 'NAV_FINANCES_VIEW_CHARGE_GROUP',
    LIST: 'ACTION_FINANCES_LIST_CHARGE_GROUP',
    CREATE: 'ACTION_FINANCES_CREATE_CHARGE_GROUP',
    EDIT: 'ACTION_FINANCES_EDIT_CHARGE_GROUP',
    VIEW: 'ACTION_FINANCES_VIEW_CHARGE_GROUP',
  },
  CUSTOMER_AGREEMENT: {
    NAV: 'NAV_FINANCES_VIEW_CUSTOMER_AGREEMENT',
    LIST: 'ACTION_FINANCES_LIST_CUSTOMER_AGREEMENT',
    CREATE: 'ACTION_FINANCES_CREATE_CUSTOMER_AGREEMENT',
    EDIT: 'ACTION_FINANCES_EDIT_CUSTOMER_AGREEMENT',
    VIEW: 'ACTION_FINANCES_VIEW_CUSTOMER_AGREEMENT',
  },
  RECEIPTS: {
    NAV: 'NAV_FINANCES_VIEW_RECEIPT'
  },
  CREDIT_NOTE: {
    NAV: 'NAV_FINANCES_VIEW_CREDIT_NOTE',
    LIST: 'ACTION_FINANCES_LIST_CREDIT_NOTE',
    VIEW: 'ACTION_FINANCES_VIEW_CREDIT_NOTE',
    CREATE: 'ACTION_FINANCES_CREATE_CREDIT_NOTE',
  },
  REBATE: {
    NAV: "NAV_FINANCES_VIEW_REBATE_CONFIG",
    VIEW: "ACTION_REBATE_VIEW_REBATE_CONFIG",
    LIST: "ACTION_REBATE_LIST_REBATE_CONFIG",
    CREATE: "ACTION_REBATE_SAVE_REBATE_CONFIG"
  },
  WEIGHMENT: {
    LIST: 'NAV_OPERATIONS_WEIGHMENT_LIST',
    VIEW: 'NAV_OPERATIONS_WEIGHMENT_VIEW',
    CREATE: 'NAV_OPERATIONS_WEIGHMENT_ADD',
  }
};
